/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-block-editor/#useBlockProps
 */
import { useBlockProps, InspectorControls } from '@wordpress/block-editor';
import { PanelBody, TextControl, ToggleControl, SelectControl, withFocusOutside } from '@wordpress/components';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */
export default function Edit({ attributes, setAttributes }) {
	const blockProps = useBlockProps();

	let iframeCSS = {
		border: "none"
	};

	//let iframeCSS  = 'border:none;';
	let widthText  = '';
	let heightText = '';
	const scrolling = true === attributes.iframeBlockScrolling ? 'yes' : 'no';

	if ( true === attributes.iframeBlockResponsiveWidth ) {
		widthText  = 'Width (%)';
		iframeCSS['width'] = attributes.iframeBlockWidth + '%';

	} else {
		widthText  = 'Width (px)';
		iframeCSS['width'] = attributes.iframeBlockWidth + 'px';
	}

	if ( true === attributes.iframeBlockResponsiveHeight ) {
		heightText = 'Height (%)';
		iframeCSS['height'] = attributes.iframeBlockHeight + '%';
	} else {
		heightText = 'Height (px)';
		iframeCSS['height'] = attributes.iframeBlockHeight + 'px';
	}

	return (
		<div { ...useBlockProps() }>
			<InspectorControls key="setting">

				<div id="iframe-block-controls">
					<PanelBody>
						<TextControl
							{ ...blockProps }
							label={  __('Iframe URL', 'iframe-block') }
							value={ attributes.iframeBlockSrc }
							onChange={ ( value ) => setAttributes( { iframeBlockSrc: value } ) }
						/>

						<div className={'panel-row'}>
							<label>{widthText}</label>
							<ToggleControl
								label={ __('Responsive', 'iframe-block') }
								checked={ attributes.iframeBlockResponsiveWidth }
								onChange={ ( value ) => { setAttributes( {iframeBlockResponsiveWidth: value } ) } }
							/>
						</div>

						<TextControl
							{ ...blockProps }
							value={ attributes.iframeBlockWidth }
							onChange={ ( value ) => setAttributes( { iframeBlockWidth: value } ) }
						/>

							<div className={'panel-row'}>
							<label>{heightText}</label>
							<ToggleControl
								label={ __('Responsive', 'iframe-block') }
								checked={ attributes.iframeBlockResponsiveHeight }
								onChange={ ( value ) => { setAttributes( {iframeBlockResponsiveHeight: value } ) } }
							/>
						</div>

						<TextControl
							{ ...blockProps }
							value={ attributes.iframeBlockHeight }
							onChange={ ( value ) => setAttributes( { iframeBlockHeight: value } ) }
						/>
						<ToggleControl
							label={ __('Allow Full Screen', 'iframe-block') }
							checked={ attributes.iframeBlockFullScreen }
							onChange={ ( value ) => { setAttributes( {iframeBlockFullScreen: value } ) } }
						/>

						<ToggleControl
							label={ __('Lazy Loading', 'iframe-block') }
							checked={ attributes.iframeBlockLoading }
							onChange={ ( value ) => { setAttributes( {iframeBlockLoading: value } ) } }
						/>
						<ToggleControl
							label={ __('Scrolling', 'iframe-block') }
							checked={ attributes.iframeBlockScrolling }
							onChange={ ( value ) => { setAttributes( {iframeBlockScrolling: value } ) } }
						/>

						<ToggleControl
							label={ __('Hide Frame', 'iframe-block') }
							checked={ attributes.iframeBlockHideFrame }
							onChange={ ( value ) => { setAttributes( {iframeBlockHideFrame: value } ) } }
						/>

					</PanelBody>
				</div>
			</InspectorControls>

			<div className={'iframe-block-editor-area'} style={ true === attributes.iframeBlockHideFrame ? {'border' : 'none'} : {} } >

				{
					false === attributes.iframeBlockHideFrame ?

						<div className={'iframe-block-heading'}>
							<TextControl
								{ ...blockProps }
								placeholder={'Please enter the iframe URL.'}
								class={'iframe-block-url'}
								value={ attributes.iframeBlockSrc }
								onChange={ ( value ) => setAttributes( { iframeBlockSrc: value } ) }
							/>
							<button className={'iframe-block-button'} onClick={ () => setAttributes( {iframeBlockHideFrame: true } ) }>Hide Frame</button>
						</div>

					: ''
				}

				<div className={'iframe-block-iframe'}>
					{
						typeof attributes.iframeBlockSrc !== 'undefined' && attributes.iframeBlockSrc.length > 5 ?

								true === attributes.iframeBlockFullScreen ?

								<iframe src={attributes.iframeBlockSrc} style={iframeCSS} frameBorder={0} scrolling={scrolling} allowFullScreen={"allowFullScreen"}></iframe>
								:
								<iframe src={attributes.iframeBlockSrc} style={iframeCSS} frameBorder={0} scrolling={scrolling}></iframe>

						: ''
					}
				</div>
			</div>

		</div>
	);
}
